// uses es6 but there's no transpiling and this is not critical code so it's not problemo
try {
  const embeds = Array.from(document.querySelectorAll('#page iframe, #trailerVid'));
  const foundEmbeds = embeds.length > 0;
  const siteLang = document.querySelector('html').getAttribute('lang');

  let embedInfoCreated = false;
  let cookiesAccepted = false;
  let interval = setInterval(cookieChecker, 200);

  // functions
  function cookieChecker() {
      if (!foundEmbeds) {
          clearInterval(interval);
          return;
      }

      if (!cookiesAccepted && (!window.OptanonActiveGroups.indexOf('C0004') > -1)) {
          cookiesAccepted = window.OptanonActiveGroups.indexOf('C0004') > -1 ? true : false;

          if (!embedInfoCreated) {
              embedInfoCreated = true;
              createEmbedInfos();
          }
      } else {
          Array.from(document.querySelectorAll('.js-embed-information')).map(item => item.remove());
          clearInterval(interval);
      }
  }

  function createEmbedInfos() {
      if (!foundEmbeds) {
          clearInterval(interval);
          return;
      }

      const langTexts = {
        'en-US': {
            'heading': 'If you wish to view embedded content, please accept cookies',
            'buttonText': 'Accept cookies'
        },
        'fi': {
            'heading': 'Hyväksy evästeet nähdäksesi upotettu sisältö',
            'buttonText': 'Hyväksy evästeet'
        },
        'sv-SE': {
            'heading': 'Acceptera riktade kakor för att se inbäddat innehåll',
            'buttonText': 'Acceptera kakor'
        }
    };

      embeds.map(item => {

        let placeholderSrc = '';

        let src = '';
        if (item.hasAttribute('data-src')) {
          src = item.getAttribute('data-src');
        } else if (item.hasAttribute('src')) {
          src = item.getAttribute('src');
        }

        if (src.indexOf('youtube') > -1 ) {
          let youtubeId = src.split('embed/')[1];
          youtubeId = youtubeId.split('?')[0];
          youtubeId = youtubeId.split('&')[0];
          youtubeId = youtubeId.split('#')[0];
          if (youtubeId) {
            placeholderSrc = `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
          }
        }

        let embedInfoMarkup = `
          <div class="js-embed-information embed-information" style="background-image:url('${placeholderSrc}')">
            <div class="embed-information__overlay">
              <span class="embed-information__heading">
                ${langTexts[siteLang]['heading']}
              </span>
              <a href="#" role="button" class="ot-sdk-show-settings embed-information__button">${langTexts[siteLang]['buttonText']}</a>
            </div>
          </div>
        `;
          item.insertAdjacentHTML( 'beforebegin', embedInfoMarkup );
      });
  }
} catch (e) {
  console.error(e);
}
